import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { predefinedPricingTiersActions } from '../actions/predefined-pricing-tiers.actions';
import { PredefinedPricingTierValue } from '../models';
import { selectLoaded, selectLoading, selectSaved, selectSaving, selectTiers } from '../selectors/predefined-pricing-tiers.selector';

@Injectable({
    providedIn: 'root',
})
export class PredefinedPricingTiersFacade {
    private readonly store = inject(Store);

    readonly tiers = this.store.selectSignal(selectTiers);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly loaded = this.store.selectSignal(selectLoaded);
    readonly saving = this.store.selectSignal(selectSaving);
    readonly saved = this.store.selectSignal(selectSaved);

    getTiers(): void {
        this.store.dispatch(predefinedPricingTiersActions.getTiers());
    }

    saveTiers(value: PredefinedPricingTierValue[]): void {
        this.store.dispatch(predefinedPricingTiersActions.saveTiers({ value }));
    }

    clear(): void {
        this.store.dispatch(predefinedPricingTiersActions.clear());
    }
}
